import {
  Menu,
  Search,
  ShoppingBag,
  UserRound,
  X
} from "lucide-react";

import {
  useState
} from "react";

import {
  Link,
  NavLink
} from "react-router";

import {
  useCart
} from "../../context/CartContext";

const navigation = [
  {
    label: "Home",
    path: "/"
  },
  {
    label: "Shop",
    path: "/shop"
  },
  {
    label: "Our Story",
    path: "/our-story"
  },
  {
    label: "Ingredients",
    path: "/ingredients"
  },
  {
    label: "Making RiNi",
    path: "/making-rini"
  },
  {
    label: "Gift Hampers",
    path: "/gift-hampers"
  }
];

export function Header() {
  const {
    itemCount
  } =
    useCart();

  const [
    mobileOpen,
    setMobileOpen
  ] =
    useState(false);

  function closeMobileMenu() {
    setMobileOpen(false);
  }

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-[#5e3b2c]/10 bg-[#fffdf8]/95 backdrop-blur">
        <div className="rini-container flex h-20 items-center justify-between gap-3 sm:gap-6">
          <button
            type="button"
            onClick={() =>
              setMobileOpen(true)
            }
            className="flex h-11 w-11 items-center justify-center rounded-full transition hover:bg-[#f1e9dc] lg:hidden"
            aria-label="Open navigation"
            aria-expanded={
              mobileOpen
            }
          >
            <Menu size={24} />
          </button>

          <Link
            to="/"
            className="shrink-0 text-center"
            aria-label="RiNi Bodycare home"
          >
            <span className="block font-serif text-3xl font-semibold tracking-[0.08em] text-[#5e3b2c]">
              RiNi
            </span>

            <span className="block text-[9px] font-semibold tracking-[0.32em] text-[#70845b]">
              BODYCARE
            </span>
          </Link>

          <nav className="hidden flex-1 items-center justify-center gap-7 lg:flex">
            {navigation.map(
              (item) => (
                <NavLink
                  key={
                    item.path
                  }
                  to={
                    item.path
                  }
                  className={({
                    isActive
                  }) =>
                    [
                      "text-sm font-medium transition-colors",
                      isActive
                        ? "text-[#5e3b2c]"
                        : "text-[#625b54] hover:text-[#5e3b2c]"
                    ].join(" ")
                  }
                >
                  {
                    item.label
                  }
                </NavLink>
              )
            )}
          </nav>

          <div className="flex items-center gap-0.5 sm:gap-2">
            <button
              type="button"
              className="flex h-11 w-11 items-center justify-center rounded-full transition hover:bg-[#f1e9dc]"
              aria-label="Search"
            >
              <Search size={21} />
            </button>

            <button
              type="button"
              className="hidden h-11 w-11 items-center justify-center rounded-full transition hover:bg-[#f1e9dc] sm:flex"
              aria-label="Customer account"
            >
              <UserRound size={20} />
            </button>

            <Link
              to="/cart"
              className="relative flex h-11 w-11 items-center justify-center rounded-full transition hover:bg-[#f1e9dc]"
              aria-label={`Shopping cart with ${itemCount} items`}
            >
              <ShoppingBag
                size={21}
              />

              {itemCount > 0 && (
                <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#70845b] px-1 text-[10px] font-bold text-white">
                  {itemCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </header>

      {/* Mobile backdrop */}

      {mobileOpen && (
        <button
          type="button"
          aria-label="Close navigation"
          onClick={
            closeMobileMenu
          }
          className="fixed inset-0 z-[60] bg-black/35 backdrop-blur-[1px] lg:hidden"
        />
      )}

      {/* Mobile navigation drawer */}

      <aside
        className={[
          "fixed inset-y-0 left-0 z-[70] w-[86%] max-w-[360px] bg-[#fffdf8] shadow-2xl transition-transform duration-300 ease-out lg:hidden",
          mobileOpen
            ? "translate-x-0"
            : "-translate-x-full"
        ].join(" ")}
        aria-hidden={
          !mobileOpen
        }
      >
        <div className="flex h-full flex-col">
          <div className="flex items-center justify-between border-b border-[#5e3b2c]/10 px-6 py-5">
            <Link
              to="/"
              onClick={
                closeMobileMenu
              }
              className="text-left"
            >
              <span className="block font-serif text-3xl font-semibold tracking-[0.08em] text-[#5e3b2c]">
                RiNi
              </span>

              <span className="block text-[9px] font-semibold tracking-[0.32em] text-[#70845b]">
                BODYCARE
              </span>
            </Link>

            <button
              type="button"
              onClick={
                closeMobileMenu
              }
              className="flex h-11 w-11 items-center justify-center rounded-full bg-[#f3ede5] text-[#5e3b2c]"
              aria-label="Close navigation"
            >
              <X size={22} />
            </button>
          </div>

          <nav className="flex-1 overflow-y-auto px-4 py-5">
            <div className="space-y-1">
              {navigation.map(
                (item) => (
                  <NavLink
                    key={
                      item.path
                    }
                    to={
                      item.path
                    }
                    onClick={
                      closeMobileMenu
                    }
                    className={({
                      isActive
                    }) =>
                      [
                        "flex min-h-14 items-center rounded-2xl px-4 text-base font-semibold transition",
                        isActive
                          ? "bg-[#efe3d2] text-[#5e3b2c]"
                          : "text-[#514a45] hover:bg-[#f6f0e8]"
                      ].join(" ")
                    }
                  >
                    {
                      item.label
                    }
                  </NavLink>
                )
              )}
            </div>

            <div className="my-5 border-t border-[#5e3b2c]/10" />

            <Link
              to="/cart"
              onClick={
                closeMobileMenu
              }
              className="flex min-h-14 items-center justify-between rounded-2xl bg-[#5e3b2c] px-5 font-semibold text-white"
            >
              <span className="flex items-center gap-3">
                <ShoppingBag
                  size={19}
                />
                Shopping Cart
              </span>

              <span className="flex h-7 min-w-7 items-center justify-center rounded-full bg-white/15 px-2 text-xs">
                {itemCount}
              </span>
            </Link>
          </nav>

          <div className="border-t border-[#5e3b2c]/10 p-5">
            <p className="text-xs uppercase tracking-[0.18em] text-[#70845b]">
              Need help?
            </p>

            <a
              href="https://wa.me/917338225556"
              target="_blank"
              rel="noreferrer"
              className="mt-3 flex min-h-12 items-center justify-center rounded-full bg-[#70845b] px-5 text-sm font-semibold text-white"
            >
              WhatsApp RiNi
            </a>
          </div>
        </div>
      </aside>
    </>
  );
}
